var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWecoLogo = function SvgWecoLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.532,
    height: 270.444,
    viewBox: "0 0 62.582 71.555",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    overflow: "visible",
    refX: 0,
    refY: 0
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "red",
    strokeOpacity: 1,
    strokeWidth: ".8pt",
    d: "M10 0l4-4L0 0l14 4z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    overflow: "visible",
    refX: 0,
    refY: 0
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "red",
    strokeOpacity: 1,
    strokeWidth: ".8pt",
    d: "M10 0l4-4L0 0l14 4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient887"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51a6dd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64cdad",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter863",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient889",
    x1: 76.166,
    x2: 139.55,
    y1: 128.958,
    y2: 93.411,
    gradientTransform: "translate(-1.891 -5.484)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient887"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline",
    filter: "url(#filter863)",
    opacity: 0.998,
    transform: "translate(-74.542 -70.056)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient889)",
    fillOpacity: 1,
    strokeDasharray: "0.422826, 1.26848",
    strokeWidth: 0.423,
    d: "M104.688 141.304l-29-16.743a2.291 2.291 60 01-1.146-1.985V89.09a2.291 2.291 120 011.146-1.984l29-16.743a2.291 2.291 180 012.291 0l29 16.743a2.291 2.291 60 011.146 1.984v33.486a2.291 2.291 120 01-1.146 1.985l-29 16.743a2.291 2.291 0 01-2.291 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.265,
    d: "M104.884 104.01V74.248c0-.731-.513-1.027-1.146-.662l-6.1 3.522c-.633.365-1.146 1.254-1.146 1.984v21.193c0 .425-.298.942-.666 1.155-.492.284-.89-.079-.89-.81V80.129c0-.73-.514-1.026-1.146-.661l-5.948 3.434c-.633.365-1.146 1.254-1.146 1.984v20.805c0 .467-.327 1.034-.73 1.267-.468.27-.846-.104-.846-.835V85.808c0-.73-.513-1.027-1.146-.662L77.993 88.6c-.633.365-1.146 1.254-1.146 1.984v29.797c0 .73.511 1.024 1.142.655 8.58-5.018 17.168-10.026 25.753-15.037.63-.368 1.142-1.26 1.142-1.99z",
    paintOrder: "normal"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.265,
    d: "M108.12 106.105l25.773 14.88c.632.366 1.145.07 1.145-.661v-7.044c0-.73-.513-1.62-1.145-1.985L115.54 100.7c-.369-.212-.667-.73-.667-1.155 0-.567.513-.731 1.146-.366l17.756 10.251c.633.366 1.146.07 1.146-.661V101.9c0-.73-.513-1.619-1.146-1.984l-18.018-10.403c-.404-.233-.731-.8-.731-1.266 0-.54.513-.68 1.146-.315l17.592 10.157c.633.366 1.146.07 1.146-.661V90.52c0-.73-.513-1.62-1.146-1.984L107.96 73.638c-.633-.365-1.142-.07-1.138.661.056 9.94.1 19.881.146 29.822.003.73.52 1.619 1.152 1.984z",
    paintOrder: "normal"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.265,
    d: "M104.622 107.737l-25.773 14.88c-.633.366-.633.958 0 1.323l6.1 3.522c.633.366 1.659.366 2.291 0l18.353-10.596c.369-.212.966-.212 1.334 0 .492.284.377.81-.256 1.176l-17.756 10.251c-.633.366-.633.958 0 1.323l5.948 3.434c.632.365 1.658.365 2.291 0l18.018-10.403c.404-.233 1.058-.233 1.462 0 .467.27.333.785-.3 1.15l-17.593 10.157c-.632.365-.632.958 0 1.323l5.982 3.453c.633.366 1.659.366 2.291 0l25.805-14.898c.633-.365.631-.955-.004-1.316-8.636-4.922-17.267-9.855-25.899-14.784-.634-.363-1.662-.36-2.294.005z",
    opacity: 0.7,
    paintOrder: "normal"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWecoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/weco-logo.39a47729efc21ce617fa7c90ca29815e.svg";